import React, { useMemo } from 'react';
import Currency from 'react-currency-formatter';
import { useTranslation } from 'react-i18next';
// material-ui
import { TableCell, TableRow } from '@mui/material';
import useImage from 'services/Hooks/useImage';
import { useLanguageReference } from 'services/Hooks/useLanguageReference';
import { arrayUnique } from 'services/Utilities/Utilities';
import { ProjectInventoryItemAdjustmentTypeEnumValue } from 'enums/ProjectInventoryItemAdjustmentTypeEnum';

// Icons

// Styles

// Actions
// Components

// Others

const DealerCopyAdjustmentDefaultCategorySection = ({
  categoryLabel,
  projectInventoryItems,
  headerColSpan,
  projectAdjustments = [],
  currencyName,
}) => {
  const { t } = useTranslation();
  const { getInventoryItemImage } = useImage();
  const { descriptionReference } = useLanguageReference();

  const uniqueInventoryItemSkus = useMemo(() => arrayUnique(projectAdjustments.map(pa => pa.inventoryItem_Id)), [
    projectAdjustments,
  ]);

  return (
    <>
      <TableRow>
        <TableCell colSpan={headerColSpan} style={{ backgroundColor: '#c9c7c7' }}>
          <strong>{categoryLabel}</strong>
        </TableCell>
      </TableRow>
      {uniqueInventoryItemSkus?.map(inventoryItemId => {
        const associatedProjectAjustements = projectAdjustments.filter(pa => pa.inventoryItem_Id === inventoryItemId);

        const firstProjectAjustement = associatedProjectAjustements[0];

        const totalQuantity = associatedProjectAjustements.reduce((acc, cur) => acc + (cur.quantity || 0), 0);
        const projectInventoryItem = projectInventoryItems.find(pi => pi.inventoryItem_Id === inventoryItemId);

        return (
          <TableRow key={projectInventoryItem?.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell colSpan={2}>
              {projectInventoryItem?.files?.length > 0 && (
                <img
                  src={getInventoryItemImage(projectInventoryItem?.inventoryItem_Id, projectInventoryItem?.files[0].id)}
                  alt={t('InventoryItemImage')}
                  style={{
                    maxHeight: '50px',
                    width: '100%',
                    objectFit: 'contain',
                  }}
                />
              )}
            </TableCell>
            <TableCell>
              <strong>{`${projectInventoryItem?.sku}`}</strong>
            </TableCell>
            <TableCell colSpan={2}>{projectInventoryItem?.[descriptionReference]}</TableCell>
            {firstProjectAjustement ? (
              <TableCell align="center">
                {(firstProjectAjustement.adjustmentType === ProjectInventoryItemAdjustmentTypeEnumValue.DealerInventory
                  ? Math.abs(totalQuantity)
                  : totalQuantity) || '0'}
              </TableCell>
            ) : (
              <TableCell>-</TableCell>
            )}
            <TableCell align="right">
              {projectInventoryItem?.projectDealerUnitPrice === 0 ? (
                '-'
              ) : (
                <Currency quantity={projectInventoryItem?.projectDealerUnitPrice} currency={currencyName} />
              )}
            </TableCell>
            {firstProjectAjustement ? (
              <TableCell align="right">
                <Currency
                  quantity={(totalQuantity || 0) * projectInventoryItem?.projectDealerUnitPrice}
                  currency={currencyName}
                />
              </TableCell>
            ) : (
              <TableCell>-</TableCell>
            )}
            <TableCell></TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default DealerCopyAdjustmentDefaultCategorySection;
